<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'session'"></ContentLoader>
    </div>
    <div v-else>
      <!-- class="carouselContainer" -->
      <div v-if="data && data.length">
        <Carousel>
          <div v-for="d in data" :key="d.id">
            <router-link
              :to="{
                name: getRouterName(d),
                params: {
                  id: getParamsId(d),
                },
              }"
            >
              <!-- <SessionCard :data="d" /> -->
              <Card :isFavourite="true" :data="d" :redirectpath="{name: 'UserSessionDetails', params: { id: d.session_id }}"/>
            </router-link>
          </div>
        </Carousel>
      </div>
      <span class="text-xs text-gray-700" v-else>No data found.</span>
    </div>
  </section>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import SessionCard from "@/components/SessionCard";
import Card from "@/components/card/Card.vue";
import { Carousel } from "@/components/t-components";

export default {
  name: "RecommendedSessionCardListCarousel",
  components: {
    ContentLoader,
    Carousel,
    SessionCard,
    Card,
  },
  props: {
    data: {
      type: Array,
    },
    statusCode: {
      type: Number,
    },
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
};
</script>